import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LogIn, Shield } from "lucide-react";
import api, { formatApiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("cc_admin_token", r.data.access_token);
      toast.success("Accesso effettuato");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-slate-50">
      <div className="hidden lg:flex lg:w-1/2 bg-slate-900 text-white p-12 flex-col justify-between">
        <div>
          <img
            src="/logo-unioncasa-white.png"
            alt="UnionCasa"
            className="w-72 mb-6 select-none"
            data-testid="login-logo"
          />
          <h1 className="font-serif text-5xl font-light tracking-tight leading-tight">
            Pannello <br /> Amministratore
          </h1>
          <p className="text-slate-400 mt-6 max-w-sm leading-relaxed">
            Gestione delle richieste di Attestazione Canone Concordato per il Comune di Milano.
            Accordo territoriale del 12/06/2023.
          </p>
        </div>
        <div className="text-xs text-slate-500">
          Accesso riservato al personale autorizzato.
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-6 lg:p-12">
        <div className="w-full max-w-md">
          <div className="mb-8">
            <div className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-green-800 mb-3">
              <Shield size={14} /> Area Riservata
            </div>
            <h2 className="font-serif text-3xl text-slate-900 mb-2">Accedi al pannello</h2>
            <p className="text-slate-500 text-sm">Inserisci le tue credenziali per continuare</p>
          </div>

          <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1.5"
                data-testid="login-email"
              />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1.5"
                data-testid="login-password"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-slate-900 hover:bg-slate-800 text-white"
              data-testid="login-submit"
            >
              <LogIn size={16} className="mr-2" />
              {loading ? "Accesso..." : "Accedi"}
            </Button>
          </form>

          <p className="text-xs text-slate-500 mt-4 text-right">
            <a href="/admin/password-dimenticata" className="hover:text-slate-900 hover:underline" data-testid="admin-forgot-password-link">
              Password dimenticata?
            </a>
          </p>

          <p className="text-xs text-slate-400 mt-8 text-center">
            <a href="/" className="underline">← Torna al modulo pubblico</a>
          </p>
        </div>
      </div>
    </div>
  );
}
